import React from 'react';
import { IcebergExperience } from './IcebergExperience';

// /iceberg — standalone IJsbergmethode-pagina (zoals in de originele app).
export default function IcebergPage() {
  return (
    <div style={{ minHeight: '100vh', background: '#050a14' }} data-testid="iceberg-page">
      <IcebergExperience />
    </div>
  );
}
